<template>
    <div class="container" @click="clickProductOrder">
      <el-row>
        <el-col :span="11"><span class="title-text">{{$t('common.productOrderNo')}}: {{data.productOrderNo}}</span></el-col>
        <el-col :span="11">发货数量: {{countVal(data.prodInfos)}}</el-col>
        <el-col :span="2"><span class="spread-text" @click.stop="changeShow">{{isShow ? $t('incomeApp.retract') : $t('incomeApp.spread')}}</span></el-col>
      </el-row>
      <el-row>
        <el-col :span="11">{{$t('common.orderTime')}}: {{formatDate(data.createAt)}}</el-col>
        <el-col :span="11">产品型号: {{productVal(data.prodInfos)}}</el-col>
      </el-row>
      <div v-if="isShow">
        <el-row>
          <el-col :span="11">{{$t('common.customerName')}}: {{data.customer && data.customer.customerName}}</el-col>
          <el-col :span="11">{{$t('common.contact')}}: {{data.contact}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="11">{{$t('common.contactPhone')}}: {{data.contactPhone}}</el-col>
          <el-col :span="11">{{$t('common.address')}}: {{data.contactAddr}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="11">{{$t('deliveryGoods.requestExpress')}}: {{expressageVal(data.expressage)}}</el-col>
          <el-col :span="11">{{$t('common.expressageType')}}: {{expressageTypeVal(data.expressageType)}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="11">{{$t('incomeApp.associatedBoxes')}}: {{associatedBoxList && associatedBoxList.length === 0 ? $t('common.empty') : ''}}</el-col>
        </el-row>
        <div v-if="associatedBoxList && associatedBoxList.length > 0">
          <el-table
            :data="associatedBoxList"
            style="margin-bottom: 10px;"
            :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
            :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
            :span-method="objectSpanMethod">
            <el-table-column
              :label="$t('common.number')"
              prop="index"
              width="50">
            </el-table-column>
            <el-table-column prop="prodInfo" label="产品型号">
              <template slot-scope="scope">
                {{scope.row.productName + ' / ' + scope.row.chipName}}
              </template>
            </el-table-column>
            <el-table-column prop="boxNo" :label="$t('common.boxNo')"></el-table-column>
            <el-table-column prop="binLevel" :label="$t('common.binLevel')"></el-table-column>
            <el-table-column prop="lotNo" :label="$t('common.lotNo')"></el-table-column>
            <el-table-column prop="count" :label="$t('common.count')" width="60"></el-table-column>
            <el-table-column :label="$t('common.operate')" width="80">
              <template slot-scope="scope">
                <el-button type="text" class="link" @click.stop="delBox(scope.row)">
                  {{$t('incomeApp.disassociatedBox')}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import { storeStatus, expressages, expressageTypes } from '@/utils/defines';
import { delBoxPut, tporderDetail } from '@/api/tpProdOrder';

export default {
  name: 'ProductOrder',
  props: [
    'data',
    'index',
  ],
  data() {
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.explain;
      }
    }
    const expressagesObj = {};
    let expressagesItem;
    for (const key in expressages) {
      if (Object.prototype.hasOwnProperty.call(expressages, key)) {
        expressagesItem = expressages[key];
        expressagesObj[expressagesItem.val] = expressagesItem.explain;
      }
    }
    const expressageTypesObj = {};
    let expressageTypesItem;
    for (const key in expressageTypes) {
      if (Object.prototype.hasOwnProperty.call(expressageTypes, key)) {
        expressageTypesItem = expressageTypes[key];
        expressageTypesObj[expressageTypesItem.val] = expressageTypesItem.explain;
      }
    }
    return {
      isShow: false,
      storeStatusObj,
      expressagesObj,
      expressageTypesObj,
      associatedBoxList: [],
    };
  },
  methods: {
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    expressageVal(val) {
      return this.expressagesObj[`${val}`];
    },
    expressageTypeVal(val) {
      return this.expressageTypesObj[`${val}`];
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm:ss');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
    },
    changeShow() {
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.tporderDetail();
      }
    },
    clickProductOrder() {
      this.isShow = false;
      this.$emit('click', this.data, this.index);
    },
    async tporderDetail() {
      const {
        productOrderNo,
      } = this.data;
      try {
        const res = await tporderDetail({ productOrderNo });
        const {
          data,
        } = res;
        const {
          detail
        } = data;
        this.associatedBoxList = [];
        if (detail) {
          let info, length, index = 0, prodInfo;
          detail.prodStores.map(row => {
            info = row.info;
            length = info.length;
            for (let i = 0; i < length; i++) {
              if (i === 0) {
                index++;
                this.associatedBoxList.push({
                  boxNo: row.boxNo,
                  ...info[i],
                  rowspan: length,
                  index: index,
                });
              } else {
                this.associatedBoxList.push({
                  boxNo: row.boxNo,
                  ...info[i],
                })
              }
            }
          });
        }
      } catch (e) {
        // do nothing.
      }
    },
    delBox(row) {
      const {
        productOrderNo,
      } = this.data;
      const {
        boxNo,
      } = row;
      this.$confirm(this.$t('incomeApp.thisActionWillDisassociatedBox'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        await delBoxPut({ productOrderNo, boxNos: [boxNo] });
        this.$message({
          type: 'success',
          message: this.$t('common.disassociateSuccess'),
        });
        this.tporderDetail();
      }).catch(() => {
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 3 && columnIndex !== 4) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
    productVal(prodInfos) {
      let product = [];
      for(let prodInfo of prodInfos){
        product.push(prodInfo.prodInfo + ' (' + prodInfo.count + ') ');
      }
      return product.join(' , ');
    },
    countVal(prodInfos) {
      let allCount = 0;
      for(let prodInfo of prodInfos){
        allCount = allCount + prodInfo.count;
      }
      return allCount;
    }
  },
};
</script>

<style scoped>
  .container {
    margin: 0 15px 8px;
    width: calc(100% - 30px);
    box-sizing: border-box;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    color: #606266;
    font-size: 14px;
    border-bottom: 1px solid #dddddd;
  }
  .title-container {
    box-sizing: border-box;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .title-text {
    color: #1F232E;
    font-size: 15px;
  }
  .spread-text {
    color: #4889ED;
    padding: 0 5px;
  }
  .el-col {
    padding: 5px 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
</style>
